import React from "react";
import {
  NavLink as RouterLink,
  useLocation,
} from "react-router-dom";

import {
  Button,
  List,
  ListItemButton,
  ListItem,
  Typography,
  Divider,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import Collapse from "@mui/material/Collapse";

const TrainerAssessmentDropdown = () => {
  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");
  const splitLoc = splitLocation[3];
  const splitLoc1 = splitLocation[2];

  const [open, setOpen] = React.useState(false);

  const handleClick = () => {
    setOpen(!open);
  };

  return (
    <>
      {localStorage.getItem("group") === "trainer" ? (
        <div>
          <ListItemButton
            disableGutters
            sx={{
              display: "flex",
              py: 0.5,
              pl: 1,
            }}
            onClick={handleClick}
          >
            <Typography color="white" variant="h6">
              Assessment
            </Typography>
            {open ? (
              <ArrowDropUpIcon style={{ marginLeft: "auto", color: "white" }} />
            ) : (
              <ArrowDropDownIcon
                style={{ marginLeft: "auto", color: "white" }}
              />
            )}
          </ListItemButton>

          <Collapse in={open} timeout="auto" unmountOnExit>
            <Divider style={{ backgroundColor: "rgb(6 57 108)" }} />
            <List component="div" disablePadding>
              <li className="px-3 rounded-lg mb-1 text-gray-700">
                <ListItem
                  disableGutters
                  sx={{
                    display: "flex",
                    py: 0,
                  }}
                >
                  <Button
                    component={RouterLink}
                    sx={{
                      color: "#ffff",
                      fontWeight: "medium",
                      justifyContent: "flex-start",
                      letterSpacing: 0,
                      py: 0.5,
                      textTransform: "none",
                      width: "100%",
                      ...(splitLoc1 === "create"
                        ? {
                            backgroundColor: "rgb(6 57 108)",
                            color: "#2cbcd3",
                          }
                        : ""),
                      "& svg": {
                        mr: 1,
                      },
                    }}
                    to="/app/trainerquiztable"
                  >
                    <span>Create</span>
                  </Button>
                </ListItem>

                <ListItem
                  disableGutters
                  sx={{
                    display: "flex",
                    py: 0,
                  }}
                >
                  <Button
                    component={RouterLink}
                    sx={{
                      color: "#ffff",
                      fontWeight: "medium",
                      justifyContent: "flex-start",
                      letterSpacing: 0,
                      py: 0.5,
                      textTransform: "none",
                      width: "100%",
                      ...(splitLoc1 === "view"
                        ? {
                            backgroundColor: "rgb(6 57 108)",
                            color: "#2cbcd3",
                          }
                        : ""),
                      "& svg": {
                        mr: 1,
                      },
                    }}
                    to="/app/traineview"
                  >
                    <span>View</span>
                  </Button>
                </ListItem>

                <ListItem
                  disableGutters
                  sx={{
                    display: "flex",
                    py: 0,
                  }}
                >
                  <Button
                    component={RouterLink}
                    sx={{
                      color: "#ffff",
                      fontWeight: "medium",
                      justifyContent: "flex-start",
                      letterSpacing: 0,
                      py: 0.5,
                      textTransform: "none",
                      width: "100%",
                      ...(splitLoc1 === "edit"
                        ? {
                            backgroundColor: "rgb(6 57 108)",
                            color: "#2cbcd3",
                          }
                        : ""),
                      "& svg": {
                        mr: 1,
                      },
                    }}
                    to="/app/traineredit"
                  >
                    <span>Edit</span>
                  </Button>
                </ListItem>

                <ListItem
                  disableGutters
                  sx={{
                    display: "flex",
                    py: 0,
                  }}
                >
                  <Button
                    component={RouterLink}
                    sx={{
                      color: "#ffff",
                      fontWeight: "medium",
                      justifyContent: "flex-start",
                      letterSpacing: 0,
                      py: 0.5,
                      textTransform: "none",
                      width: "100%",
                      ...(splitLoc1 === "assign"
                        ? {
                            backgroundColor: "rgb(6 57 108)",
                            color: "#2cbcd3",
                          }
                        : ""),
                      "& svg": {
                        mr: 1,
                      },
                    }}
                    to="/app/trainerassign"
                  >
                    <span>Assign</span>
                  </Button>
                </ListItem>
                <ListItem
                  disableGutters
                  sx={{
                    display: "flex",
                    py: 0,
                  }}
                >
                  <Button
                    component={RouterLink}
                    sx={{
                      color: "#ffff",
                      fontWeight: "medium",
                      justifyContent: "flex-start",
                      letterSpacing: 0,
                      py: 0.5,
                      textTransform: "none",
                      width: "100%",
                      ...(splitLoc1 === "manage"
                        ? {
                            backgroundColor: "rgb(6 57 108)",
                            color: "#2cbcd3",
                          }
                        : ""),
                      "& svg": {
                        mr: 1,
                      },
                    }}
                    to="/app/trainermanage"
                  >
                    <span>Manage</span>
                  </Button>
                </ListItem>
                <ListItem
                  disableGutters
                  sx={{
                    display: "flex",
                    py: 0,
                  }}
                >
                  <Button
                    component={RouterLink}
                    sx={{
                      color: "#ffff",
                      fontWeight: "medium",
                      justifyContent: "flex-start",
                      letterSpacing: 0,
                      py: 0.5,
                      textTransform: "none",
                      width: "100%",
                      ...(splitLoc1 === "score"
                        ? {
                            backgroundColor: "rgb(6 57 108)",
                            color: "#2cbcd3",
                          }
                        : ""),
                      "& svg": {
                        mr: 1,
                      },
                    }}
                    to="/app/trainerscore"
                  >
                    <span>Score</span>
                  </Button>
                </ListItem>
              </li>
            </List>
          </Collapse>
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default TrainerAssessmentDropdown;
